<div class="w-full flex flex-col items-center px-4 mobile:px-0 max-w-2xl mx-auto">
 
    <div class="w-full mobile:w-auto border-4 rounded-xl p-6 border-red-600 bg-red-100 space-y-3 text-center max-w-xl mx-auto">
        <div class="font-bold">STOP! PLEASE READ</div>

        <div>
            DO NOT use this form for regalia hire if you are attending a traditional graduation from:
            <ol>
                <li>University of Canterbury | Autumn or Spring Graduations</li>
                <li>Lincoln University | Autumn Graduation</li>
                <li>Ara Institute of Canterbury | Autumn or Spring Graduation</li>
            </ol>
        </div>
    
        <div>
            A link will be sent from your institution if you are eligible and registered for one of these graduations.
        </div>
    </div>

    <div class="mt-6 w-full mobile:w-auto flex mobile:block">
        <button mat-stroked-button  color="warn" (click)="goToFirstStep()" class="w-full mobile:w-auto">Continue to Casual Hire</button>
    </div>
 
    
         
</div>